// extracted by mini-css-extract-plugin
export default {"pdfMobilePreview":"PreviewModal_pdfMobilePreview__v85oE","pdfDesktopPreview":"PreviewModal_pdfDesktopPreview__GZM3h"};